
import * as THREE from 'three'
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel';
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Range from 'vux/src/components/range/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


import { initThree, camera, renderer, scene, currentModel, updateModel } from './initThree';
import loading from '@/components/loading';
import { getThreeFonts } from '../../../3dapps/js/fontManage.js';


const contentList = [
"齐思印3D小软件",
"不负青春,不负自己",
"新年快乐",
"高考加油",
"祝你生日快乐",
"张晓明",
"0123456789",
"大吉大利,今晚吃鸡"
];


export default {
name: "word",
mixins: [printModel],
components: {
XDialog, loading, Range, Cell
},
data() {
return {
quotationName: "3D文字",
productType: "3D字",
landscape: true,//竖屏状态要一直为true
showPrint: false,
showText: false,
showSize: false,
showFonts: false,
isreliefBtnIndex: -1,//顶部按钮默认
fontsItemIndex: 1,//初始值-字体
wordData: {
fontSize: 30, // 长
d: 1.5, // 厚
Radian: 50, //弧度
text: contentList[Math.floor(Math.random() * contentList.length)],
font: "",
},
showbtnSure: true,
showLoading: false,
addCartIndex: -1,
orderIndex: -1,
fontsData: [],
btnsList: [//按钮列表
{
isClick: false,
icon: require("../../../3dapps/imgs/nowImgs/字体.png"),
iconClick: require("../../../3dapps/imgs/nowImgs/文字选中.png"),
title: "文字",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/nowImgs/字体.png"),
iconClick: require("../../../3dapps/imgs/nowImgs/字体选中.png"),
title: "字体",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/nowImgs/尺寸.png"),
iconClick: require("../../../3dapps/imgs/nowImgs/尺寸选中.png"),
title: "尺寸",
},
],
}
},
mounted() {
const scope = this;
scope.showLoading = true;
scope.loadlistBrand();

var mo = function (e) {
e.preventDefault();
}


var tabList = this.$refs.bottomPopup; 

var screenHeight = window.innerHeight;
window.onresize = function () {
if (screenHeight !== window.innerHeight) {

tabList.style.bottom = 1 + "rem";
tabList.style.position = "absolute";
} else {

tabList.style.bottom = 1 + "rem";
tabList.style.position = "fixed";
}
};
window.addEventListener("resize", onresize);


var interval;


tabList.onfocus = function () {
interval = setInterval(function () {
tabList.style.bottom = 1 + "rem";
tabList.style.position = "absolute";
}, 500)
};


tabList.onblur = function () {
tabList.style.bottom = 1 + "rem";
tabList.style.position = "fixed";
clearInterval(interval);
};


scope.$nextTick(function () {
scope.$refs.word.style.paddingTop = '0rem';
scope.$refs.word.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);
});


const contentDOM = scope.$refs.word;

const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

scope.init3d(contentDOM, camera, renderer, resize1);

initThree(scope.$refs.canvas);

setTimeout(function () {
scope.showLoading = false;
scope.touchstart();


}, 50);

scope.$nextTick(function () {
scope.loadData();
});
},
methods: {












































































loadData() {
const scope = this;
if (window.localStorage) {
let dataStr = localStorage.getItem("wordData");
localStorage.removeItem("wordData"); 
if (dataStr) {
let data = JSON.parse(dataStr);
scope.wordData.fontSize = data.fontSize;
scope.wordData.d = data.d;
scope.wordData.font = data.font;
scope.wordData.text = data.text;
scope.wordData.Radian = data.Radian;
scope.fontsItemIndex = data.fontsItemIndex;

scope.showLoading = true;

setTimeout(function () {
scope.showLoading = false;
}, 50);
}
}
},


saveData() {
if (window.localStorage) {
let data = {};
data.fontSize = this.wordData.fontSize;
data.d = this.wordData.d;
data.font = this.wordData.font;
data.text = this.wordData.text;
data.fontsItemIndex = this.fontsItemIndex;
data.Radian = this.wordData.Radian;
localStorage.setItem("wordData", JSON.stringify(data));
}
},


loadlistBrand() {
const scope = this;


getThreeFonts(this).then(fontsDisp => {
scope.fontsData = fontsDisp;
scope.wordData.font = scope.fontsData[1].fontName;
scope.refresh3d();
});
},

exporter() {
let exporter = new THREE.STLExporter();
let result = exporter.parse(currentModel, {
binary: true
});
let blob = new Blob([result], {
type: 'application/octet-stream'
});

let filename = "model.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
},

isTopBtn() {
this.isreliefBtnIndex = -1;
this.showSize = false;
this.showFonts = false;
this.showText = false;
this.showPrint = false;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.btnsList[2].isClick = false;
},

touchend() {
setTimeout(() => {
this.showLoading = false;
}, 1000);
},


onfontsItemClick(index) {
const scope = this;
scope.showFonts = false;
scope.fontsItemIndex = index;
scope.showLoading = true;
scope.wordData.font = scope.fontsData[scope.fontsItemIndex].fontName;

setTimeout(function () {
scope.isTopBtn();
scope.refresh3d().then(function () {
scope.showLoading = false;
});
scope.isNoData();
}, 50);
},

refresh3d() {
return updateModel(this, this.wordData.font, this.wordData.text, this.wordData.fontSize, THREE.Math.degToRad(this.wordData.Radian));
},


handler(index) {
if (index === 0) {//文字
this.isreliefBtnIndex = index;
this.showText = true;
this.showSize = false;
this.showFonts = false;
this.showPrint = false;
this.btnsList[0].isClick = true;
this.btnsList[2].isClick = false;
this.btnsList[1].isClick = false;
this.updatedData();
return;
} else if (index === 1) {//字体
this.isreliefBtnIndex = index;
this.showFonts = true;
this.showSize = false;
this.showText = false;
this.showPrint = false;
this.btnsList[1].isClick = true;
this.btnsList[0].isClick = false;
this.btnsList[2].isClick = false;
this.updatedData();
return;
} else if (index === 2) {//尺寸
this.isreliefBtnIndex = index;
this.showSize = true;
this.showText = false;
this.showFonts = false;
this.showPrint = false;
this.btnsList[2].isClick = true;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.updatedData();
return;
}
},


touchstart() {
this.isTopBtn();
this.updatedData();
},


isClickText() {
if (this.wordData.text == "") {
this.$vux.toast.show({
text: '文本输入不能为空！',
type: "cancel",
time: 2000,
position: "middle",
});
this.showText = true;
return;
}
this.isTopBtn();
},


isClickFont() {
if (this.wordData.font == "") {
this.$vux.toast.show({
text: '字体选中不能为空！',
type: "cancel",
time: 2000,
position: "middle",
});
this.showFonts = true;
return;
}
this.isTopBtn();
},


isClickSize() {
if (this.wordData.fontSize == "" || this.wordData.Radian == "") {
this.$vux.toast.show({
text: '尺寸不能为空！',
type: "cancel",
time: 2000,
position: "middle",
});
this.showSize = true;
return;
}
this.isTopBtn();
},


isClickPrint() {











this.isTopBtn();
},


selectText() {
this.showText = !this.showText;
this.showPrint = false;
this.showSize = false;
},


onChangeText() {
if (this.wordData.text === '' || this.wordData.text === null) {
this.$vux.toast.show({
text: '文本输入不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.wordData.text = "齐思印";
this.showText = true;
return;
}
this.isTopBtn();
this.showLoading = true;
setTimeout(() => {
const _this = this;
this.refresh3d().then(function () {
_this.showLoading = false;
});
}, 50);
},


selectSize() {
this.showSize = !this.showSize;
this.showText = false;
this.showPrint = false;
},




updatedData() {
if (this.wordData.fontSize == "" && this.wordData.Radian == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showFonts = false;
this.showText = false;
this.showLoading = false;
} else if (this.wordData.text == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.showText = true;
this.showSize = false;
this.showFonts = false;
this.showLoading = false;
} else if (this.wordData.fontSize < 30) {
this.$vux.toast.show({
text: '最小长度为30毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (this.wordData.fontSize > 200) {
this.$vux.toast.show({
text: '最大长度为200毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
}





















else if (this.wordData.Radian < 50) {
this.$vux.toast.show({
text: '最小弧度为50角度',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (this.wordData.Radian > 80) {
this.$vux.toast.show({
text: '最大弧度为80角度',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
}

setTimeout(() => {
const _this = this;
_this.refresh3d().then(function () {
_this.showLoading = false;
});
}, 50);
},

isNoData() {
const scope = this;
if (scope.wordData.fontSize == "" && scope.wordData.Radian == "") {
scope.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
scope.wordData.fontSize = 30;

scope.wordData.Radian = 50;
scope.showSize = true;
scope.showFonts = false;
scope.showText = false;
scope.showLoading = false;
scope.refresh3d();
} else if (scope.wordData.text == "") {
scope.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
scope.wordData.text = "齐思印";
scope.showText = true;
scope.showSize = false;
scope.showFonts = false;
scope.showLoading = false;
}
},

cancelPop() {
this.isTopBtn();
this.updatedData();
},

isSure() {
this.showLoading = true;
this.isTopBtn();
this.updatedData();
},


downloads() {
const scope = this;
scope.showLoading = true;

if (currentModel) {

if (!this.$common.getCookie('_token')) {

scope.saveData();

this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
});
scope.showLoading = false;
} else {
scope.$request.post('/SmallSoftware/requestDownload', {
type: "word",
}).then(function (res) {
if (res.obj === true) {
scope.downloadModels();
setTimeout(() => {
scope.$vux.toast.show({
text: '下载成功',
type: "success",
time: 2000,
position: "middle",
});
scope.isTopBtn();
scope.showLoading = false;
}, 50);
} else {
scope.$vux.toast.show({
text: '下载失败',
type: "warn",
time: 2000,
position: "middle",
});
}
});
}
}
},


print() {
this.isTopBtn();
this.showSize = false;
this.showText = false;
this.showFonts = false;

this.showLoading = true;
this.isNoData();



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showlowpriceHeight = true;
}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showlowpriceHeight = false;
}

if (currentModel) {
this.saveData();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
const scope = this;
this.getPrice().then(() => {
scope.showLoading = false;
});
});
} else {
this.$vux.toast.show({
text: '3D文字不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.refresh3d().then(function () {
this.showLoading = false;
});
}
















},


downloadModels() {
let exporter = new THREE.STLExporter();
let group = currentModel;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });

let filename = "文字.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
},

makeStlBlob() {
let exporter = new THREE.STLExporter();
let result = exporter.parse(currentModel, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
},

getModelToPrint() { return currentModel; },
},
watch: {
'wordData.text': function () {
if (this.wordData.text == "") {
this.showbtnSure = false;
return;
} else {
this.showbtnSure = true;
}
}
},
}



// WEBPACK FOOTER //
// ./src/views/word3d/scripts/index.js